import { createFileRoute } from "@tanstack/react-router";
import { ProductPage, buildProductHead } from "@/components/shop/ProductPage";
import { metalDictEl } from "@/lib/shop/products/metal";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/el/shop_/metal")({
  head: () => ({
    ...buildProductHead(metalDictEl),
    links: alternateLinkList("/shop/metal", "el"),
  }),
  component: () => <ProductPage dict={metalDictEl} />,
});
